import React from 'react'

export default function addBarcode(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M30.3 8.8V32c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2V4C1.8 2.2 3.2.7 5 .7h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6.9.6 1.5Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M25.02 7c.56 0 1.01.52 1.12 1.17v9.61c-.11.65-.56 1.17-1.12 1.17v.01H6.12c-.56 0-1.12-.39-1.12-1.04V8.3c0-.65.45-1.17 1.01-1.3h19.01ZM7.71 9.13v.06h-.06v7.64h.11v-.06h.28V9.13h-.33Zm-1 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.33V9.13h-.33Zm.56 0v7.64h.11V9.13h-.11Zm.66 0v7.64h.11V9.13h-.11Zm.55 0v7.64h.33V9.13H8.7Zm.34 0v7.64h.11V9.13h-.11Zm.44 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.33V9.13H9.7Zm.44 0v7.64h.33V9.13h-.33Zm.34 0v7.64h.11V9.13h-.11Zm.33 0v7.64h.22V9.13h-.22Zm.55 0v7.64h.33V9.13h-.33Zm.45 0v7.64h.33V9.13h-.33Zm.44 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.33V9.13h-.33Zm.44 0v7.64h.33V9.13h-.33Zm.45 0v7.64h.11V9.13h-.11Zm.33 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.11V9.13h-.11Zm.33 0v7.64h.44V9.13h-.44Zm.56 0v7.64h.33V9.13h-.33Zm.55 0v7.64h.11V9.13h-.11Zm.33 0v7.64h.44V9.13h-.44Zm.67 0v7.64h.44V9.13h-.44Zm.77 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.33V9.13h-.33Zm.45 0v7.64h.11V9.13h-.11Zm.44 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.44V9.13h-.44Zm.56 0v7.64h.11V9.13h-.11Zm.22 0v7.64H20V9.13h-.33Zm.66 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.33V9.13h-.33Zm.45 0v7.64h.11V9.13H21Zm.33 0v7.64h.11V9.13h-.11Zm.33 0v7.64h.33V9.13h-.33Zm.44 0v7.64h.33V9.13h-.33Zm.34 0v7.64h.11V9.13h-.11Zm.33 0v7.64h.11V9.13h-.11Zm.33 0v7.64h.11V9.13h-.11Zm.22 0v7.64h.44V9.13h-.44Zm.55 0v7.64h.11V9.13h-.11Zm.23 0v7.64h.33V9.13h-.33Z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
  )
}
